import { makeStyles } from 'tss-react/mui';
import { colors, hideScrollbars, spacing } from '../../styles/jss/variables';
import { IMAGE_ITEM_WIDTH_MOBILE, LARGE_IMAGE_ITEM_WIDTH, SMALL_IMAGE_ITEM_WIDTH } from './CategoryLinkGallery';
const useStyles = makeStyles()((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: spacing.small,
    },
    categoryTitle: Object.assign(Object.assign(Object.assign({}, theme.typography.medium_bold), theme.typographySpacing.medium_bold_sm), { textAlign: 'center', [theme.breakpoints.up('sm')]: Object.assign(Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.large_bold_sm), { marginBottom: 0 }) }),
    smallImageVariantTitle: {},
    // Carousel wrapper with arrow controls
    carouselWrapper: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
    },
    touchButtonWrapper: {
        display: 'flex',
        width: '44px',
        height: '44px',
        padding: '6px',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 20,
    },
    arrowButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        height: spacing.large,
        width: spacing.large,
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.24)',
        borderRadius: '50% !important',
        border: `1px solid ${theme.isFlyingFlowers ? '#E71F68' : '#8d6a00'}`,
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        flexShrink: 0,
        '&:hover': {
            backgroundColor: colors.supplementary.white,
            borderColor: theme.isFlyingFlowers ? '#E71F68' : '#8d6a00',
        },
        '&:active': {
            backgroundColor: colors.black[100],
        },
        '& .MuiIcon-root': {
            color: theme.isFlyingFlowers ? '#E71F68' : '#8D6A00',
        },
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    leftArrow: {
        left: 0,
    },
    rightArrow: {
        right: 0,
    },
    linksContainer: Object.assign(Object.assign({ display: 'flex', position: 'relative', overflowX: 'auto', overflowY: 'hidden' }, hideScrollbars), { flex: 1, scrollBehavior: 'smooth', gap: 4, [theme.breakpoints.down('md')]: {
            '-webkit-overflow-scrolling': 'touch',
            gap: spacing.xs,
        } }),
    textIconCarouselViewport: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        minWidth: 0,
    },
    customCarouselList: {
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
        margin: '0 auto',
    },
    customCarouselTrack: {
        display: 'flex',
        gap: 4,
        transition: 'transform 320ms ease',
        willChange: 'transform',
    },
    customCarouselTrackCentered: {
        justifyContent: 'center',
    },
    smallImageLinksContainer: {
        minWidth: 0,
        gap: spacing.xs,
        [theme.breakpoints.up('md')]: {
            gap: 4,
        },
    },
    linksContainerCentered: {
        justifyContent: 'center',
    },
    // Text and Icon Variant
    textIconWrapper: {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        gap: spacing.xs,
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
        },
    },
    textIconWrapperOverflow: {
        justifyContent: 'flex-start',
    },
    textIconItem: {
        display: 'flex',
        alignItems: 'center',
        gap: spacing.small,
        whiteSpace: 'nowrap',
        flexShrink: 0,
        border: '1px solid #000000',
        borderRadius: 4,
        padding: '10px 12px',
        backgroundColor: colors.supplementary.white,
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: '#f6f6f6',
        },
        [theme.breakpoints.down('md')]: {
            '&:not(:last-child):after': {
                content: 'none',
            },
        },
        [theme.breakpoints.up('sm')]: {
            '&:not(:last-child):after': {
                content: 'none',
            },
        },
    },
    categoryLink: Object.assign(Object.assign({}, theme.typography.xxs_regular), { color: theme.isFlyingFlowers ? '#3C3C3B' : '#000000', textDecoration: 'none', [theme.breakpoints.up('sm')]: Object.assign({}, theme.typography.small_regular) }),
    // Small Image Variant
    smallImageWrapper: {
        display: 'flex',
        gap: spacing.xs,
        width: '100%',
        [theme.breakpoints.up('md')]: {
            gap: 4,
        },
    },
    smallImageCarouselViewport: {
        width: '100%',
        minWidth: 0,
    },
    smallImageCarouselItem: {
        display: 'flex',
        justifyContent: 'center',
        flex: '0 0 auto',
        boxSizing: 'border-box',
        '&:hover': {
            '& p': {
                textDecoration: 'none',
            },
        },
    },
    smallImageItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        textDecoration: 'none',
        width: IMAGE_ITEM_WIDTH_MOBILE,
        minWidth: IMAGE_ITEM_WIDTH_MOBILE,
        maxWidth: IMAGE_ITEM_WIDTH_MOBILE,
        flex: `0 0 ${IMAGE_ITEM_WIDTH_MOBILE}px`,
        [theme.breakpoints.up('md')]: {
            width: SMALL_IMAGE_ITEM_WIDTH,
            minWidth: SMALL_IMAGE_ITEM_WIDTH,
            maxWidth: SMALL_IMAGE_ITEM_WIDTH,
            flex: `0 0 ${SMALL_IMAGE_ITEM_WIDTH}px`,
        },
        gap: 0,
        '& :hover': {
            textDecoration: 'none',
        },
    },
    smallImageContainer: {
        position: 'relative', // required for next/image fill
        width: IMAGE_ITEM_WIDTH_MOBILE,
        height: IMAGE_ITEM_WIDTH_MOBILE,
        [theme.breakpoints.up('md')]: {
            width: SMALL_IMAGE_ITEM_WIDTH,
            height: SMALL_IMAGE_ITEM_WIDTH,
        },
        overflow: 'hidden',
        backgroundColor: colors.supplementary.white,
    },
    smallImageLabelContainer: {
        padding: '4px 8px 4px 0',
    },
    smallImage: {
        display: 'block',
        width: '100%',
        height: '100% !important', //to override the height set by NextImage component
        objectFit: 'cover',
    },
    smallImageLabel: Object.assign(Object.assign({}, theme.typography.xxs_regular), { margin: 0, padding: 0, color: theme.isFlyingFlowers ? '#3C3C3B' : colors.supplementary.black, textAlign: 'left', textDecoration: 'underline', wordBreak: 'break-word', whiteSpace: 'normal', [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.small_regular) }),
    // Large Image Variant
    largeImageCarouselViewport: {
        width: '100%',
        minWidth: 0,
    },
    largeImageCarouselItem: {
        display: 'flex',
        justifyContent: 'center',
        flex: '0 0 auto',
        boxSizing: 'border-box',
        '& :hover': {
            '& p': {
                textDecoration: 'none',
            },
        },
    },
    largeImageWrapper: {
        display: 'flex',
        gap: spacing.xs,
        flexWrap: 'wrap',
        width: '100%',
        [theme.breakpoints.up('md')]: {
            gap: 4,
        },
    },
    largeImageItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        textDecoration: 'none',
        width: IMAGE_ITEM_WIDTH_MOBILE,
        minWidth: 0,
        flex: '0 1 auto',
        gap: 0,
        maxWidth: IMAGE_ITEM_WIDTH_MOBILE,
        [theme.breakpoints.up('md')]: {
            width: LARGE_IMAGE_ITEM_WIDTH,
            maxWidth: LARGE_IMAGE_ITEM_WIDTH,
        },
    },
    largeImageContainer: {
        position: 'relative', // required for next/image fill
        width: IMAGE_ITEM_WIDTH_MOBILE,
        maxWidth: IMAGE_ITEM_WIDTH_MOBILE,
        aspectRatio: '1',
        overflow: 'hidden',
        backgroundColor: colors.supplementary.white,
        [theme.breakpoints.up('md')]: {
            width: LARGE_IMAGE_ITEM_WIDTH,
            maxWidth: LARGE_IMAGE_ITEM_WIDTH,
        },
    },
    largeImage: {
        display: 'block',
        width: '100%',
        height: '100% !important', //to override the height set by NextImage component
        objectFit: 'cover',
    },
    largeImageContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 0,
        width: '100%',
        padding: '4px 8px 4px 0',
    },
    largeImageLabelContainer: {
        padding: '4px 8px 4px 0',
        width: '100%',
        boxSizing: 'border-box',
    },
    largeImageLabel: Object.assign(Object.assign({}, (theme.isFlyingFlowers ? theme.typography.xxs_bold : theme.typography.xxs_regular)), { textAlign: 'left', textDecoration: 'underline', color: theme.isFlyingFlowers ? '#3C3C3B' : colors.supplementary.black, margin: 0, padding: 0, wordBreak: 'break-word', whiteSpace: 'normal', [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.small_bold) }),
}));
export default useStyles;
